
/* Disconnect the theme's cart drawer functionality so it doesn't conflict with Rebuy */
  // Stop the theme's "open drawer" handlers, but only for the theme's forms
  document.addEventListener('add-to-cart', function(e) {
    var t = e.target;
    if (!t || !(t instanceof Element)) return;

    var isThemeForm =
      t.matches('[data-js-product-form]') ||
      t.matches('product-form') && t.closest('quick-add-to-cart');

    if (isThemeForm) {
      e.stopImmediatePropagation(); // prevents that anonymous listener from running
    }
  }, true); // capture phase so we run before the theme's bubble listener






  